import React, { memo } from "react";
import { generateFields } from ".";
import ChildForm from "./ChildForm";

const GroupForm = ({
  input,
  control,
  defaultValues,
  setValue,
  errors,
  getValues,
  parentName = "",
}) => {
  const { name, label, alignment = {}, isObject = false } = input;
  const { sm = 12, md = 12, lg = 12 } = alignment;

  const fullName = parentName ? `${parentName}.${name}` : name;

  return (
    <div className={`form-group mb-3 col-sm-${sm} col-md-${md} col-lg-${lg}`}>
      <fieldset
        style={{ border: "1px solid #b4b4b4" }}
        className="mb-3"
      >
        <legend>{label}</legend>
        <div className="row" style={{ padding: "10px" }}>
          {input?.children?.map((childField) => {
            const field = { ...childField };
            const { name: childName } = field;
            const error = errors[name]?.message;
            const defaultValue = defaultValues?.[name] || "";

            if (isObject){
              field.name = `${name}.${childName}`;
            }


            // Handle nested grouped fields recursively
            if (field?.children?.length > 0 && field.isGroupField) {
              return (
                <GroupForm
                  key={childName}
                  input={field}
                  control={control}
                  defaultValues={defaultValues}
                  setValue={setValue}
                  errors={errors}
                  getValues={getValues}
                  parentName={fullName}
                />
              );
            }

            // Handle nested dynamic rows
            if (field?.children?.length > 0 && field.isMoreRow) {
              return (
                <ChildForm
                  key={childName}
                  input={field}
                  control={control}
                  defaultValues={defaultValues}
                  setValue={setValue}
                  errors={errors}
                  getValues={getValues}
                />
              );
            }

            return generateFields(
              field,
              control,
              error,
              defaultValue,
              setValue,
              getValues,
              field?.variant
            );
          })}
        </div>
      </fieldset>
    </div>
  );
};

export default memo(GroupForm); 